// Centralised UI/HTTP/file-size constants — keeps magic numbers out of components.
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
};

export const UI_TIMEOUTS = {
  NOTIFICATION_POLL_MS: 20000,
};

export const FILE_SIZE = {
  BYTES_PER_KB: 1024,
  BYTES_PER_MB: 1024 * 1024,
  MAX_ATTACHMENT_BYTES: 3 * 1024 * 1024,
};

export const DIGEST_WINDOW = {
  DEFAULT_DAYS: 7,
  EXTENDED_DAYS: 30,
};

// Dev-only console wrapper — keeps error info out of prod console while
// preserving rich debugging in development.
export const devError = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(...args);
  }
};
